import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { business } from '../data/business';
import { ui } from '../data/translations';
export function MobileCallBar() {
  const {
    t
  } = useLanguage();
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-white/10 bg-navy p-3 md:hidden" data-id="element-171" data-mp="2ef7u3k93wyn6">
      <a href={business.phoneHref} className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border-2 border-white/60 font-display text-sm font-semibold text-white" data-id="element-172" data-mp="24nbto2jjswfs">
        <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="1upnoeiobg6jd" />
        {t(ui.cta.callNow)}
      </a>
      <a href="#contact" className="flex h-12 items-center justify-center whitespace-nowrap rounded-md bg-gold font-display text-sm font-semibold text-navy-deep" data-id="element-174" data-mp="1zn7d6cin41pk">
        {t(ui.cta.estimateShort)}
      </a>
    </div>;
}